<template>
  <div id="coupon_pop">
    <div class="pop_content">
      <div class="clear">
        <img src="@/assets/img/coupon/close.svg" alt @click="close" />
      </div>
      <div class="pop_title">
        <div class="title">全部礼券</div>
        <div class="explain" @mouseover="lookuse()">
          礼券使用说明
          <i class="fa fa-wenhao"></i>
          <div class="use_info" v-show="useState">
            <i class="top"></i>
            <p v-for="(item,index) in useInfo" :key="index">{{item.data}}</p>
          </div>
        </div>
      </div>
      <div class="coupon_list" v-if="couponList.length>0">
        <div
          v-for="(item,index) in couponList"
          :key="index"
          style="margin-top:16px;"
          :style="item.pickType===0?'cursor:pointer;':''"
          @click="confirm(item)"
        >
          <Coupon :couponInfo="item">
            <template #pick>
              <img :src="pick" alt v-show="pickId===item.pickId" />
              <img :src="nopick" alt v-show="pickId!==item.pickId" />
            </template>
          </Coupon>
        </div>
      </div>
            <div class="coupon_list" v-else-if="couponList.length===0" style="display: flex;align-items: center;justify-content: center;">
        <div>
          <img :src="empty" alt="">
          <div style="text-align: center;font-size:14px;color:rgba(51,51,51,0.6);margin-top:20px;">暂无礼券</div>
        </div>
      </div>
      <div class="pop_bottom">
        <div class="phone_bottom">
          <div class="pop_price" v-if="couponList.length>0">
            <span>金额抵扣：</span>
            <span>¥{{price}}</span>
          </div>
          <div>
            <el-button type="primary" @click="confirmCoupon">确定</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Coupon from '@/components/Coupon'
// import api from '@/api'
import moment from 'moment'
export default {
  props: {
    morePickId: Object,
    moreCoupon: Array
  },
  data () {
    return {
      coupon: {},
      pickId: 0,
      nopick: require('@/assets/img/coupon/unselected.svg'),
      pick: require('@/assets/img/coupon/selected.svg'),
      empty: require('@/assets/img/coupon/empty.png'),
      useState: false,
      price: 0,
      useInfo: [
        {
          data:
            '1. 礼券仅可以在购买质心官网 / 质心灵动量网站的课程时使用，不找零、无法兑现。'
        },
        {
          data:
            '2. 不同礼券适用于不同的课程，且只支持用于购买整个课程(即购买部分小课时无法使用礼券)。'
        },
        {
          data: ' 3. 礼券不可叠加使用，每个订单最多使用一张礼券。'
        },
        {
          data:
            '4. 礼券有有效时间限制，以礼券上显示的结束日期为准，超过日期后则无法使用。'
        },
        {
          data:
            '5. 生成订单后，所选的礼券会被锁定无法用于其它订单。若订单取消，则返还礼券。'
        },
        {
          data: '6. 付款成功后，退款时不会返还礼券。'
        },
        {
          data: ' 7. 礼券的最终解释权归质心教育所有。'
        }
      ],
      page: 1,
      pageSize: 100,
      couponList: [],
      activity_type: 0
    }
  },
  // inject: ['provObj'],
  components: { Coupon },
  methods: {
    // 关闭弹窗
    close () {
      this.$emit('useCoupon')
    },
    confirm (e) {
      if (e.pickType === 1) {
        return false
      } else {
        this.pickId = e.pickId
        this.price = e.price
        this.coupon = e
      }
    },
    confirmCoupon () {
      if (this.couponList.length === 0) {
        this.$emit('useCoupon')
        return false
      } else if (this.pickId === 0) {
        this.$emit('useCoupon')
        return false
      }
      this.$emit('useCoupon', this.coupon)
      this.$parent.$parent.getOrderPrice()
      //   this.coupon.price,
      //   this.coupon.pickId
      // )
    },
    lookuse () {
      this.useState = !this.useState
    },
    getCoupon () {
      this.couponList = this.moreCoupon.map(item => {
        let couponState // eslint-disable-line no-unused-vars
        let pickType
        const couponType = 'confirm'
        const warnState = 0
        const price = item.coupon_val / 100
        const date =
                moment.unix(item.start_time).format('YYYY.MM.DD') +
                '-' +
                moment.unix(item.end_time).format('YYYY.MM.DD')
        const title = item.title.slice(0, 12)
        let warn
        if (item.all_course) {
          if (item.goods_type === 5) {
            warn = '适用范围：' + '面授课中，全部课程可用'
          } else if (item.goods_type === 2) {
            warn = '适用范围：' + '直播课中，全部课程可用'
          }
        } else {
          if (item.goods_type === 5) {
            warn = '适用范围：面授课中，' + item.course_fullname + '可用'
          } else if (item.goods_type === 2) {
            warn = '适用范围：直播课中，' + item.course_fullname + '可用'
          }
        }
        if (item.couponPower === 0) {
          couponState = 1
          pickType = 1
        } else if (item.couponPower === 1) {
          couponState = 0
          pickType = 0
        }

        const pickId = item.coupon_id
        return {
          couponType,
          couponState,
          price,
          date,
          title,
          warnState,
          warn,
          pickType,
          pickId
        }
      })
    }
  },
  created () {
    this.activity_type = this.$route ? Number(this.$route.params.activity_type) : 0
    this.pickId = this.morePickId.pickId
    this.price = this.morePickId.price
    this.coupon = this.morePickId
    this.getCoupon()
  }
}
</script>
<style lang="scss">
#coupon_pop {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2000;
  left: 0;
  top: 0;
  .pop_content {
    width: 756px;
    // height: 553px;
    background: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .clear {
      position: absolute;
      top: -11px;
      right: -9px;
      cursor: pointer;
    }
    .pop_title {
      width: 89.4%;
      margin: auto;
      display: flex;
      justify-content: space-between;
      // margin: 40px 0px 24px 0px;
      margin-top: 40px;
      margin-bottom: 24px;
      .title {
        font-size: 16px;
        font-weight: 500;
      }
      .explain {
        font-size: 14px;
        color: rgba(51, 51, 51, 0.6);
        position: relative;
        i {
          margin-left: 4px;
        }
        .use_info {
          position: absolute;
          width: 605px;
          height: 203px;
          box-shadow: 0px 1px 12px 0px rgba(186, 196, 205, 0.37);
          background: white;
          z-index: 2;
          right: 0px;
          top: 32px;
          box-sizing: border-box;
          padding: 27px 16px 15px 24px;
          font-size: 13px;
          line-height: 23px;
          .top {
            position: absolute;
            top: -19px;
            right: 72px;
          }
          .top:before,
          .top:after {
            position: absolute;
            content: "";
            border-top: 10px transparent dashed;
            border-left: 10px transparent dashed;
            border-right: 10px transparent dashed;
            border-bottom: 10px #fff solid;
          }
          .top:before {
            border-bottom: 10px rgba(51, 51, 51, 0.1) solid;
          }
          .top:after {
            top: 1px; /*覆盖并错开1px*/
            border-bottom: 10px #fff solid;
          }
        }
      }
    }
    .coupon_list {
      width: 89.4%;
      margin: auto;
      border: 1px solid rgba(51, 51, 51, 0.1);
      height: 347px;
      display: flex;
      flex-wrap: wrap;
      overflow-y: scroll;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 10px 32px 5px 32px;
      box-sizing: border-box;
      margin-bottom: 32px;
    }
    .coupon_list::-webkit-scrollbar {
      display: none;
    }
    .pop_bottom {
      background: rgba(51, 51, 51, 0.03);
      height: 88px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      box-sizing: border-box;
      padding-right: 4.92%;
      .phone_bottom {
        display: flex;
        align-items: center;
        // width: 294px;
        // justify-content: space-between;
        /* padding-right: 0px; */
        // margin: auto;
        .pop_price {
          font-size: 16px;
          color: rgba(51, 51, 51, 0.6);
          span:nth-child(2) {
            color: rgba(255, 160, 0, 1);
            margin: 0px 20px 0px 0px;
          }
        }
        .el-button {
          width: 128px;
          height: 40px;
        }
      }
    }
  }
}
@media (min-width: 300px) and (max-width: 374px) {
  #coupon_pop {
    .pop_content {
      width: 96%;
      .coupon_list {
        width: 99%;
        padding: 0px 0px 12px 0px;
        justify-content: center;
        border: none;
      }
      .pop_title {
        width: 294px;
        margin-bottom: 0px;
        .explain {
          .use_info {
            width: 289px;
            height: auto;
          }
        }
      }
      .pop_bottom {
        padding-right: 0px;
        .phone_bottom {
          display: flex;
          align-items: center;
          width: 294px;
          justify-content: space-between;
          /* padding-right: 0px; */
          margin: auto;
        }
      }
    }
  }
}
@media (min-width: 375px) and (max-width: 767px) {
  #coupon_pop {
    .pop_content {
      width: 88%;
      .coupon_list {
        padding: 0px 0px 12px 0px;
        justify-content: center;
        border: none;
      }
      .pop_title {
        width: 294px;
        margin-bottom: 0px;
        .explain {
          .use_info {
            width: 289px;
            height: auto;
          }
        }
      }
      .pop_bottom {
        padding-right: 0px;
        .phone_bottom {
          display: flex;
          align-items: center;
          width: 294px;
          justify-content: space-between;
          /* padding-right: 0px; */
          margin: auto;
        }
      }
    }
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  #coupon_pop {
    .pop_content {
      width: 709px;
      .coupon_list {
        padding: 10px 15px 5px 15px;
      }
    }
  }
}
</style>
